import { KeyLabel } from '../../../../shared/domain/key-label.model';

export enum TagList {
  SALES = 'SALES',
  SUPPORT = 'SUPPORT',
  FINANCE = 'FINANCE',
  CONTRACT = 'CONTRACT',
  GENERAL = 'GENERAL',
}

export const TagListLabels = {
  SALES: 'Sales',
  SUPPORT: 'Support',
  FINANCE: 'Finance',
  CONTRACT: 'Contract',
  GENERAL: 'General',
  ACCOUNT_MANAGEMENT: 'Account management',
};

export const TagListKL = () => {
  return Object.keys(TagListLabels).map(key => new KeyLabel(key, TagListLabels[key]));
};
